/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FileIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA4ElEQVR4nO2VMQ7CMAxFOzFxBJi5Bhyg3+6QOhITHIOJsVcBISHBmdgAUS5QFJWi0tKmVcMAaiQPGf5/TmwnnvdXi0jGYNn5rO9gnVSFT/qSaYBw0djcCOuMkYsXIN1HVoDJvKk5ygA7xHYtKIRSapjq5NQI0sYcrBMimT510Xt9ZO0E4LMcjE4pNTCQwkmWnQFIs11Zi9sFABOkj0A4y2riHsD1c/IVAHJt3AOS/ooSZ13U9rFD/RzcPrSp7J3NAcmmDICagOXaPXs5B8F8VP1lkt6CJW5vLrHJvNL8Z9cDAX+2y04IHngAAAAASUVORK5CYII=)
 */
export const FileIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18 22H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h7.5c.28 0 .5.22.5.5V5a5 5 0 0 0 5 5h2.5c.28 0 .5.22.5.5V18a4 4 0 0 1-4 4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 7.94c.01.03 0 .06-.04.06H19a3 3 0 0 1-3-3V2.34c0-.03.03-.05.06-.04a3 3 0 0 1 .82.58l4.24 4.24a3 3 0 0 1 .58.82Z"
        className={colorClass}
      />
    </svg>
  );
};
